import * as React from 'react';
import { Trans, translate } from 'react-i18next';
import { useCallback } from 'react';

import { MessageBoxFunctionalLayout, Text } from 'wix-style-react';

const DuplicateRoleModal = ({ t, closeModal, onOk, duplicateTitle }) => {

    const onOkClick = useCallback(async () => {
        await onOk();
        closeModal();
    }, [onOk, closeModal]);

    return (<MessageBoxFunctionalLayout
        title={t('role.identicalRoleTitle')}
        confirmText={t('role.saveAsDuplicate')}
        cancelText={t('role.keepEditing')}
        onOk={onOkClick}
        onCancel={closeModal}
        onClose={closeModal}
        theme="blue"
        dataHook="duplicateRoleModal"
    >
        <Trans i18nKey={'role.identicalRoleText'}
               values={{ roleName: duplicateTitle }}
               dataHook="duplicateRoleModalText">
            <Text>The permissions given by this role are identical to another role:</Text>
            <Text weight="bold">duplicateTitle</Text>
        </Trans>
    </MessageBoxFunctionalLayout>);
};

export default translate()(DuplicateRoleModal);
